import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import DialogTitle from 'v2/components/Shared/DialogTitle';
import PreviewCard from 'v2/components/Shared/SelectCreditCard/previewCard';

import type { ICard } from 'v2/components/Shared/SelectCreditCard';

export const useStyles = makeStyles((theme) => ({
  button: {
    marginRight: theme.spacing(1),
  },
}));
interface IProps {
  isOpen: boolean;
  card: ICard;
  handleClose: () => void;
  onSubmit: () => void;
  isChanging: boolean;
}

const ConfirmDialog = ({ isOpen, card, handleClose, onSubmit, isChanging }: IProps) => {
  const classes = useStyles();

  return (
    <Dialog open={isOpen}>
      <DialogTitle onClose={handleClose}>
        <Typography variant='h6'>Confirmar forma de pagamento</Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant='body1'>Tem certeza que deseja utilizar o cartão abaixo para pagamento deste contrato?</Typography>
        <div className='m24' />
        <PreviewCard card={card} />
        <div className='m8' />
      </DialogContent>
      <DialogActions disableSpacing={false}>
        <div>
          <Button onClick={handleClose} className={classes.button}>
            Fechar
          </Button>
          <Button variant='contained' color='primary' className={classes.button} onClick={onSubmit} disabled={isChanging}>
            {isChanging && <CircularProgress size={10} style={{ color: '#fff', marginRight: 10 }} />}Confirmar
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
